import { useTranslation } from "react-i18next";
import { ConstantRoutes } from "../../../core/constantRoutes";
import useBreadcrumbsStore from "../../../stores/breadcrumbStore";
import { useEffect, useState } from "react";
import UploadConfigService from "../../../api/admin/uploadConfigService";

function AdminCore() {
  const { t } = useTranslation();
  
  const {addBreadcrumb, clearBreadcrumbs} = useBreadcrumbsStore();  

  const [inWork, setInWork] = useState(false);

  useEffect(() => {
    clearBreadcrumbs();
    addBreadcrumb({label: 'Core', path: ConstantRoutes.adminCore})

  }, []); 

  const resetCache = () => {
    setInWork(true);
    try{
      const uploadConfigService = new UploadConfigService();
      uploadConfigService.resetCache();
    }
    finally{
      setInWork(false);
    }
  }

  return (
    <div className="relative flex-1 flex flex-col">
      <div className="py-10">
        <label
          className="text-center cursor-pointer py-5 px-14 rounded-lg border border-primary hover:bg-primary transition duration-300 ease-in-out"
          onClick={resetCache}
        >
          {t("Reset cache")}
        </label>
      </div>
    </div>
  );
}

export default AdminCore;